export const mapArrayToMultiselectOptions = (array) => {
  return array.map(a => ({ label: a, value: a }));
}

export const mapMultiselectOptionsToArray = (multiselect) => {
  return multiselect.map(({ value }) => value)
}